export const DEFAULT_COUNTRY_CODE = "JP";
//# sourceMappingURL=forecastConstants.js.map